export default "__VITE_ASSET__T_tTfT_g__"